export default __webpack_public_path__ + "static/media/networks_image.cad2144f.webp";